import {
  StyledInputLabel,
  StyledTimeInputWrapper,
  StyledFormItemField,
  StyledTimePicker,
} from "./style";
import type { TimePickerFieldProps } from "./interfaces";
import dayjs, { Dayjs } from "dayjs";

export const TimePickerField = (props: TimePickerFieldProps) => {
  const disabledSeconds = () => {
    const allowedSeconds = [0, 10, 15, 20, 30, 45];
    return Array.from({ length: 60 }, (_, i) => i).filter(
      (second) => !allowedSeconds.includes(second)
    );
  };

  return (
    <StyledTimeInputWrapper>
      {props.label ? <StyledInputLabel>{props.label}</StyledInputLabel> : null}

      <StyledFormItemField name={props.name} rules={props.rules}>
        <StyledTimePicker
          format={"mm:ss"}
          placeholder="00:00"
          suffixIcon={null}
          allowClear={false}
          needConfirm={false}
          isEditable={props.isEditable}
          showNow={false}
          disabledTime={
            props.limitedSecondsOptions
              ? () => ({
                  disabledSeconds: disabledSeconds,
                })
              : undefined
          }
          onChange={props.onChange}
          value={toDayjs(props.value)}
          hideDisabledOptions={true}
        />
      </StyledFormItemField>
    </StyledTimeInputWrapper>
  );
};

const toDayjs = (value: number | Dayjs | undefined): Dayjs => {
  if (!value) {
    return dayjs().set("minute", 0).set("second", 0);
  }
  if (dayjs.isDayjs(value)) {
    return value;
  }
  const minutes = Math.floor(value / 60);
  const remainingSeconds = value % 60;
  return dayjs().set("minute", minutes).set("second", remainingSeconds);
};
